import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { approveOverage } from '../../store/slices/overageSlice';
import { addNotification } from '../../store/slices/notificationSlice';
import warningIcon from '../../assets/icons/warning.svg';
import closeIcon from '../../assets/icons/cross.svg';

const OverageNotification: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isVisible, setIsVisible] = useState(true);
  
  const pendingSubscriptions = useAppSelector((state) => 
    state.overage.pendingSubscriptions?.subscriptions_to_approve || []
  );
  
  const approvalLoading = useAppSelector((state) => state.overage.approvalLoading);

  // If there are no pending subscriptions or the notification is hidden, don't show
  if (pendingSubscriptions.length === 0 || !isVisible) {
    return null;
  }

  const handleApprove = async (subscriptionId: string) => {
    try {
      const result = await dispatch(approveOverage(subscriptionId)).unwrap();
      
      // If we received the approval URL, open it
      if (result.approval_url) {
        // Try to open in a new window/tab
        window.location.href = result.approval_url;
        
        // if (!newWindow) {
        //   // If the browser blocked the popup, show the notification with the URL
        //   dispatch(addNotification({
        //     type: 'info',
        //     title: t('overage.approval_required'),
        //     message: t('overage.please_click_link', { url: result.approval_url }),
        //   }));
        // } else {
        //   dispatch(addNotification({
        //     type: 'success',
        //     title: t('overage.approval_initiated'),
        //     message: result.message || t('overage.approval_window_opened'),
        //   }));
        // }
      }
    } catch (error) {
      console.error('Failed to approve overage:', error);
    }
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div className="overage-notification">
      <div className="overage-notification__content">
        <div className="overage-notification__icon">
          <img src={warningIcon} alt="attention" />
        </div>
        <div className="overage-notification__text">
          <div className="overage-notification__description">
            {t('overage.pending_approval_description', { count: pendingSubscriptions.length })}
          </div>
        </div>
        <div className="overage-notification__actions">
          {pendingSubscriptions.map((subscription: { id: string; name?: string }) => (
            <button
              key={subscription.id}
              className="overage-notification__approve-btn"
              onClick={() => handleApprove(subscription.id)}
              disabled={approvalLoading}
            >
              {approvalLoading ? t('overage.approving') : t('overage.approve')}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OverageNotification;
